import { createAction } from '@reduxjs/toolkit'

import { ILayoutItem } from 'types/GlobalDashboard'
import { TCustomFieldValue } from 'types/GlobalCustomFieldValue'

import {
  TDashboardResponse,
  TPublicDashboardResponse,
  TPutLayout
} from 'redux/api/Dashboards/types'
import { TDashboardGroupResponse } from 'types/GlobalDashboardGroup'

// tryUpdateDashboardLayout
export const updateWidgetLayout = createAction('update_widget_layout')
export const updateWidgetLayoutSuccess = createAction<{
  id: string
  layout: TPutLayout['layout']
  available_space: ILayoutItem | null
}>('update_widget_layout_success')
export const updateWidgetLayoutFailed = createAction(
  'update_widget_layout_failed'
)

// tryGetOneDashboard
export const getOne = createAction<string>('get_one_dashboard')
export const getOneSuccess = createAction<TDashboardResponse>(
  'get_one_dashboard_success'
)
export const getOneFailed = createAction<{
  id: string
  errorStatusCode?: number
}>('get_one_dashboard_failed')

// tryGetOnePublicDashboard & tryGetOneApiAccessDashboard
export const getOnePublic = createAction<string>('get_one_public_dashboard')
export const getOnePublicSuccess = createAction<TPublicDashboardResponse>(
  'get_one_public_dashboard_success'
)
export const getOnePublicFailed = createAction<{
  id: string
  errorStatusCode?: number
}>('get_one_public_dashboard_failed')

// tryCreateDashboard
export const create = createAction('create_dashboard')
export const createSuccess = createAction<{
  dashboard: TDashboardResponse
  group: TDashboardGroupResponse
}>('create_dashboard_success')
export const createFailed = createAction('create_dashboard_failed')

// tryDeleteDashboard
export const destroy = createAction('delete_dashboard')
export const destroySuccess = createAction<string>('delete_dashboard_success')
export const destroyFailed = createAction('delete_dashboard_failed')

// tryUpdateDashboard
export const update = createAction('update_dashboard')
export const updateSuccess = createAction<TDashboardResponse>(
  'update_dashboard_success'
)
export const updateFailed = createAction('update_dashboard_failed')

// tryMoveDashboard
export const move = createAction('move_dashboard')
export const moveSuccess = createAction<TDashboardResponse>(
  'move_dashboard_success'
)
export const moveFailed = createAction('move_dashboard_failed')

// tryPatchCustomFieldValue
export const patchCustomFieldValue = createAction(
  'patch_dashboard_custom_field_value'
)
export const patchCustomFieldValueSuccess = createAction<{
  id: string
  data: TCustomFieldValue
}>('patch_dashboard_custom_field_value_success')
export const patchCustomFieldValueFailed = createAction(
  'patch_dashboard_custom_field_value_failed'
)
